import { Controller } from "@hotwired/stimulus";
import { originalResponseFromTurboResponseEvent } from "../../utils/turbo_utils";

export default class extends Controller {
  onCsvImported(event) {
    const response = originalResponseFromTurboResponseEvent(event);
    if (response.ok) {
      if (this._isEmptyStatePage()) {
        location.reload();
        return;
      }

      document.dispatchEvent(new CustomEvent("catalogItems:csvImported"));
    }
  }

  _isEmptyStatePage() {
    return document.querySelector(".empty-state");
  }
}
